<template>
  <Container
    title="系统参数设置"
    :returnBtn="false"
    :addBtn="false"
    :onConfirm="onConfirm"
  >
    <div style="width: 100%; display: flex; padding-bottom: 50px">
      <el-form
        :rules="rules"
        :model="form"
        label-width="auto"
        label-position="top"
        ref="formName"
        style="display: flex; width: 100%; flex-wrap: wrap"
      >
        <el-form-item
          label="系统名称"
          style="width: 24%; margin: 0.5%"
          prop="name"
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item
          required
          label="客户端名称"
          style="width: 24%; margin: 0.5%"
          prop="appname"
        >
          <el-input v-model="form.appname" />
        </el-form-item>

        <el-form-item
          required
          label="客服电话"
          style="width: 24%; margin: 0.5%"
          prop="kftel"
        >
          <el-input v-model="form.kftel" />
        </el-form-item>

        <el-form-item
          label="Token有效期(hours)"
          style="width: 24%; margin: 0.5%"
        >
          <el-input type="number" v-model="form.token_time" />
        </el-form-item>
        <el-form-item
          label="LongToken有效期(hours)"
          style="width: 24%; margin: 0.5%"
        >
          <el-input v-model="form.longtoken_time" />
        </el-form-item>
        <el-form-item label="服务接口地址" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.serverurl" />
        </el-form-item>
        <el-form-item label="服务接口端口" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.port" />
        </el-form-item>
        <el-form-item label="文件服务地址" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.fileurl" />
        </el-form-item>
        
        <el-form-item label="微信appid" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.wxappid" />
        </el-form-item>
        <el-form-item label="微信Secret" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.wxsecret" />
        </el-form-item>

        <el-form-item label="推广赠送余额(元)" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.tggivem" />
        </el-form-item>

        <el-form-item label="推广赠送积分" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.tggivep" />
        </el-form-item>

        <el-form-item label="92油价(分)" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.oil92" />
        </el-form-item>

        <el-form-item label="95油价(分)" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.oil95" />
        </el-form-item>

        <el-form-item label="98油价(分)" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.oil98" />
        </el-form-item>

        <el-form-item label="柴油油价(分)" style="width: 24%; margin: 0.5%">
          <el-input v-model="form.oil0" />
        </el-form-item>
        
        <el-form-item label="充值赠送积分数" style="width: 24%; margin: 0.5%">
          <el-input type="number" v-model="form.rechargegp" />
        </el-form-item>
        
        <el-form-item label="充值赠送积分比例(%)" style="width: 24%; margin: 0.5%">
          <el-input type="number" v-model="form.rechargepp" />
        </el-form-item>

        <el-form-item label="加油赠送积分比例(%)" style="width: 24%; margin: 0.5%">
          <el-input type="number" v-model="form.buygivep" />
        </el-form-item>
        
      </el-form>
    </div>
  </Container>
</template>

<script>
import moment from "moment";
import config from "../../../common/config";
import { pub } from "../../../common/event";
export default {
  data: () => {
    return {
      form: {},
      rules: {},
      uploadurl:''
    };
  },
  mounted: function () {
    this.uploadurl = config.host + ":" + config.port
    this.init();
  },
  methods: {
    onConfirm: async function () {
      console.log(this.form);
      this.$refs["formName"].validate(async (valid) => {
        if (valid) {
          const ret = await this.$api.system.putSystemInfo(this.form);
          if (ret) {
            pub("success_message", "编辑成功");
            pub("sysinfochange", this.form);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    init: async function () {
      const ret = await this.$api.system.getSystemInfo();
     
      const formdb = {};
      for (let k in ret.data) {
        if (!k.includes('custom')) {
          formdb[k] = ret.data[k];
        }
      }
      console.log("formdb", formdb);
      this.form = formdb;
    },
    init1: async function () {
      const ret = await this.$api.system.getSystemInfo();
      console.log(ret);
      const fieldret = await this.$r.post(
        `common/common/getdata/dbfieldsinfo`,
        { where: { dbid: 1 } }
      );
      console.log("fieldret", fieldret);
      const farr = fieldret.data.map((e) => e.name);
      const formdb = {};
      for (let k in ret.data) {
        if (farr.includes(k)) {
          formdb[k] = ret.data[k];
        }
      }
      console.log("formdb", formdb);
      this.form = formdb;
    },
    beforeAvatarUpload: function () {},
    handleAvatarSuccess: function (e) {
      this.form.logo = e.data;
    },
  },
};
</script>

<style scoped>
.errorcss {
  border: 1px solid #ff352e88;
  border-radius: 3px;
}
</style>